// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AbbreviatedNumber_wrapper__ZldJY","helpIcon":"AbbreviatedNumber_helpIcon__Bq2gI"};